class ProductMulticolumn extends HTMLElement{
    constructor(){
        super()
        this.subscriptionSelects = this.querySelectorAll(".subscription-select");
    }

    connectedCallback() {
        if(this.subscriptionSelects) {
            this.subscriptionSelects.forEach((select) => {
                const dataset = select.dataset;

                const form = this.querySelector(`.product-form-${dataset.productId}${dataset.variantId}`);
                if(!form) return;

                const input = form.querySelector(`input[name="selling_plan"`);
                if(!input) return;

                const variantWrapper = this.querySelector(`.variant-wrapper[data-variant-id="${dataset.variantId}"]`);

                if(dataset.preselectSub === "true") {
                    this.toggleSubscription(true, input, dataset, variantWrapper);
                }
                
                select.addEventListener("change", (e) => {
                    console.log(e.target.value)
                    this.toggleSubscription(e.target.value === "subscribe", input, dataset, variantWrapper);
                });
            })
        }
    }

    toggleSubscription(active, input, dataset, variantWrapper) {
        input.value = active ? dataset.sellingPlan : null;
                        
        const pricePerUnitDiv = variantWrapper.querySelector(".price-per-unit");
        let subPricePerUnitDiv = variantWrapper.querySelector(".price-per-unit.subscription");

        const currentPriceDiv = variantWrapper.querySelector(".f-price-item--sale");
        let subCurrentPriceDiv = variantWrapper.querySelector(".f-price-item--sale.subscription");

        const discountDiv = variantWrapper.querySelector(".discount .percent");
        let subDiscountDiv = variantWrapper.querySelector(".discount .percent.subscription");

        if(active !== true) {
            // Price per unit
            pricePerUnitDiv?.classList.remove("hidden");
            subPricePerUnitDiv?.classList.add("hidden");

            // Total price
            currentPriceDiv?.classList.remove("hidden");
            subCurrentPriceDiv?.classList.add("hidden");

            // Discount percentage
            discountDiv?.classList.remove("hidden");
            subDiscountDiv?.classList.add("hidden");
            
            return;
        }

        // Price per unit
        const pricePerUnit = this.formatPrice(dataset.productSubPrice / dataset.productCount);
        
        if(pricePerUnitDiv && !subPricePerUnitDiv) {
            this.renderSubscriptionPrice(pricePerUnitDiv, `<span class="price-per-unit subscription">${pricePerUnit}</span>`);
            subPricePerUnitDiv = variantWrapper.querySelector(".price-per-unit.subscription");
        }

        pricePerUnitDiv?.classList.add("hidden");
        subPricePerUnitDiv?.classList.remove("hidden");
        
        // Total price
        const currentPrice = this.formatPrice(dataset.productSubPrice);
    
        if(currentPriceDiv && !subCurrentPriceDiv) {
            this.renderSubscriptionPrice(currentPriceDiv, `<span class="f-price-item--sale subscription">${currentPrice}</span>`);
            subCurrentPriceDiv = variantWrapper.querySelector(".f-price-item--sale.subscription");
        }

        currentPriceDiv?.classList.add("hidden");
        subCurrentPriceDiv?.classList.remove("hidden");
        
        // Discount percentage
        const discountPercentage = Math.floor((dataset.compareAtPrice - dataset.productSubPrice) / dataset.compareAtPrice * 100);
        if(discountDiv && !subDiscountDiv) {
            this.renderSubscriptionPrice(discountDiv, `<span class="percent subscription">${discountPercentage}%</span>`);
            subDiscountDiv = variantWrapper.querySelector(".discount .percent.subscription");
        }

        discountDiv?.classList.add("hidden");
        subDiscountDiv?.classList.remove("hidden");
    }

    renderSubscriptionPrice(targetElement, innerHTML) {
        const newElement = document.createElement("div");
        newElement.innerHTML = innerHTML;
        targetElement.insertAdjacentHTML("afterend", innerHTML);
    }

    formatPrice(price) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(price / 100);
    }
}
customElements.define("product-multicolumn", ProductMulticolumn)